import { render, staticRenderFns } from "./payments-editor-header.vue?vue&type=template&id=5b310a30"
import script from "./payments-editor-header.vue?vue&type=script&lang=js"
export * from "./payments-editor-header.vue?vue&type=script&lang=js"
import style0 from "./payments-editor-header.vue?vue&type=style&index=0&id=5b310a30&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports